import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import DnDFlow from './DnDNodes';
import useNodesProjectStore from './stores/useNodesProjectStore';
import { useNodesRouteBootstrap } from './hooks/useNodesRouteBootstrap';

const NodesApp = ({ demoProjectId }) => {
  const { project_id, rule_id } = useParams();
  const projectId = demoProjectId || project_id;

  useNodesRouteBootstrap(projectId, rule_id);

  const projectLoading = useNodesProjectStore((s) => s.projectLoading);

  return (
    <Container fluid style={{ height: '100%' }}>
      <Row style={{ height: '100%' }}>
        <DnDFlow loading={projectLoading} />
      </Row>
    </Container>
  );
};

export default NodesApp;
